import { render, staticRenderFns } from "./OtherLoanSummary.vue?vue&type=template&id=a5c981c4"
import script from "./OtherLoanSummary.vue?vue&type=script&lang=js"
export * from "./OtherLoanSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports